import { createSlice, PayloadAction } from '@reduxjs/toolkit';




interface ThemesState {
  code: string;
  label: string;
  border: string;
  backgroundColor: string;
  textColor: string;
  primaryColor: string;
}

const initialState: ThemesState = {
  code: 'lightTheme',
  label: 'Light Theme',
  border:'#DADCDC',
  backgroundColor: '#FFFFFF',
  textColor: '#000000',
  primaryColor: '#059ca9',
};

const themesSlice = createSlice({
  name: 'themes',
  initialState,
  reducers: {
    setThemesDetails: (state, action: PayloadAction<Partial<ThemesState>>) => {
      return { ...state, ...action.payload };
    },
    resetThemesDetails: () => initialState,
    setThemesError: (state, action: PayloadAction<string>) => {
    },
  },
});

export const { setThemesDetails, resetThemesDetails, setThemesError } = themesSlice.actions;
export default themesSlice.reducer;
